export default __webpack_public_path__ + "static/csg-learning-6b69078efc9a490d37d1321de55d5b16.png";